<!--
  患者姓名脱敏展示 + 揭示（全局复用组件）：
  行内展示脱敏姓名（maskName）+ 小眼睛；点击小眼睛弹出「个人信息」弹窗（样式对齐 Figma 查看姓名设计稿），
  展示完整 患者姓名 + 年龄（可选）。
  入参：name（姓名）、age（年龄，可选）、nameClickable（名称是否可点击并派发 nameClick 事件，默认 false）。
-->
<template>
  <span class="patient-name-age-reveal">
    <span class="pna-text" :class="{ clickable: nameClickable }" @click="onNameClick">
      {{ maskedName }}
    </span>
    <img class="pna-eye" :src="see_detail" @click.stop="visible = true" />
    <a-modal
      :maskStyle="{
        background: 'rgba(0, 0, 0, 0.3)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)'
      }"
      v-model:visible="visible"
      :footer="null"
      centered
      :width="433"
      @cancel="visible = false"
    >
      <template #title>
        <div class="modal-title">个人信息</div>
      </template>
      <div class="pna-info">
        <div class="item">
          <span class="title">患者姓名：</span>
          <span class="content">{{ name || '--' }}</span>
        </div>
        <div class="item" v-if="ageText">
          <span class="title">年龄：</span>
          <span class="content">{{ ageText }}</span>
        </div>
      </div>
    </a-modal>
  </span>
</template>

<script setup>
import { computed, ref, defineProps, defineEmits } from 'vue'
import { maskName } from '@/utils'
import see_detail from '@/assets/img/see_detail.png'

const props = defineProps({
  // 患者姓名原文（未脱敏）
  name: {
    type: String,
    default: ''
  },
  // 年龄（弹窗展示；无值则隐藏该行）
  age: {
    type: [String, Number],
    default: ''
  },
  // 名称是否可点击：开启后点击名称文本向父级派发 nameClick 事件（如打开患者档案）
  nameClickable: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['nameClick'])

// 名称点击：仅当可点击时派发 nameClick（携带原姓名），并阻止冒泡避免误触发父级点击
const onNameClick = e => {
  if (!props.nameClickable) return
  emit('nameClick', props.name)
  e.stopPropagation()
}

const visible = ref(false)
const maskedName = computed(() => maskName(props.name))
const ageText = computed(() => {
  const { age } = props
  if (age === '' || age === null || age === undefined) return ''
  // 数字年龄补「岁」；非数字（如「待完善」）原样展示
  return /^\d+$/.test(String(age)) ? `${age}岁` : String(age)
})
</script>

<style lang="scss" scoped>
.patient-name-age-reveal {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  max-width: 100%;
  .pna-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &.clickable {
      cursor: pointer;
      color: #1890ff;
    }
  }
  .pna-eye {
    display: inline-block;
    margin-left: 8px;
    color: #014ea8;
    cursor: pointer;
    width: 16px;
    height: 16px;
  }
}
.pna-info {
  font-weight: 400;
  font-size: 14px;
  .item {
    display: flex;
    margin-bottom: 12px;
    align-items: center;
    &:last-child {
      margin-bottom: 0;
    }
    .title {
      flex-shrink: 0;
      color: rgba(0, 0, 0, 0.65);
    }
    .content {
      padding: 0;
      color: #000000;
    }
  }
}
</style>
